export const signUpLink = "https://in.njuko.com/grays-run-2026"